import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '0.25rem auto 0 auto',
    width: 'calc(100vw - 7rem)'
  }
}))

export default useStyles
